"use client";

import "@/components/ui/molecules/categories/feedback.css";
import { showNextPageToast } from "@/components/ui/toast";
import { useEffect } from "react";
import { Toaster as SonnerToaster } from "sonner";

const TOAST_OPTIONS = { className: "dw-sonner-toast-reset" } as const;

/**
 * Toaster — sonner-library configuration wrapper.
 *
 * MIGRATION-STATUS: CONFIG-WRAPPER.
 *
 * Renders the third-party `sonner` library's `<Toaster>` with project-
 * specific options:
 *   - position="top-right" — toast anchor point
 *   - toastOptions.className — neutralizes sonner's default toast styling
 *     (zero padding, transparent background, no border, no shadow) so that
 *     consumers can render fully-custom toast content without competing
 *     with the library's defaults
 *
 * Sonner accepts a toast root className. That reset lives under the
 * `dw-sonner-toast-reset` identity instead of inline utility overrides.
 *
 * Source: docs/implementation-blueprint.md §8 (component contract);
 *         .claude/agent-prompts/shadcn-authoring.md (binding template, commit b35c0a615);
 *         src/components/ui/molecules/ThemeTogglerPrimitive.tsx (molecule-tier SKIP-MIGRATE precedent, commit 5deb5b2aa).
 */
function Toaster() {
    // A toast the previous page left for this one (sileo's onNextPage) shows once the toaster is mounted.
    useEffect(() => {
        showNextPageToast();
    }, []);
    return (
        // Let Sonner handle the press before keeping it out of Radix's outside-click listener.
        <div onPointerDown={(event) => event.stopPropagation()}>
            <SonnerToaster className="dw-toaster" position="top-right" toastOptions={TOAST_OPTIONS} data-component="Toaster" data-location="src/components/ui/shadcn/sonner.tsx"/>
        </div>
    );
}

export { Toaster };
